
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-face-swap",
      function () {
        return require("private-next-pages/ai-face-swap/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-face-swap"])
      });
    }
  